import LoginPage from "./pages/LoginPage";
import AuthLayout from "../shared/layouts/AuthLayout";

import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage"; // optional
import RequireVerifiedProbationer from "../auth/components/RequireVerifiedProbationer";

import VerifyEmailPage from "./pages/VerifyEmailPage";
import AuthGuard from "../../lib/authGuard";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import CompleteProfilePage from "./pages/CompleteProfilePage";
import ProfilePage from "./pages/ProfilePage";
import PayApplicationFee from "./pages/PayApplicationFee";
import OnboardingGuard from "../../lib/onboardingGuard";
import GuestGuard from "../../lib/guestGuard";

export const authRoutes = [
  {
    path: "/",
    element: (
      <GuestGuard>
        <AuthLayout>
          <LoginPage />
        </AuthLayout>
      </GuestGuard>
    ),
    public: true,
  },
  {
    path: "/login",
    element: (
      <GuestGuard>
        <AuthLayout>
          <LoginPage />
        </AuthLayout>
      </GuestGuard>
    ),
    public: true,
  },
  {
    path: "/register",
    element: (
      <GuestGuard>
        <AuthLayout>
          <RegisterPage />
        </AuthLayout>
      </GuestGuard>
    ),
    public: true,
  },
  {
    path: "/forgot-password",
    element: (
      <GuestGuard>
        <AuthLayout>
          <ForgotPasswordPage />
        </AuthLayout>
      </GuestGuard>
    ),
    public: true,
  },

  // ✅ optional but recommended (if you're using reset token)
  {
    path: "/reset-password",
    element: (
      <AuthLayout>
        <ResetPasswordPage />
      </AuthLayout>
    ),
    public: true,
  },

  {
    path: "/verify-email",
    element: (
      <AuthLayout>
        <OnboardingGuard>
          <VerifyEmailPage />
        </OnboardingGuard>
      </AuthLayout>
    ),
    public: true,
  },
  {
    path: "/pay-application-fee",
    element: (
      <AuthLayout>
        <OnboardingGuard>
          <PayApplicationFee />
        </OnboardingGuard>
      </AuthLayout>
    ),
    public: true,
  },

  {
    path: "/change-password",
    element: (
      <AuthGuard>
        <OnboardingGuard>
          <ChangePasswordPage />
        </OnboardingGuard>
      </AuthGuard>
    ),
  },

  {
    path: "/complete-profile",
    element: (
      <AuthGuard>
        <OnboardingGuard>
          <CompleteProfilePage />
        </OnboardingGuard>
      </AuthGuard>
    ),
  },
];
